import { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Store } from "lucide-react";
import { createAgencyClient } from "@/lib/api";
import { ApiProvider } from "@/lib/apiClient";
import CallbackNotifier from "@/components/CallbackNotifier";
import { VoiceProvider } from "@/context/VoiceContext";
import {
  AgencyWorkspaceProvider, useAgencyWorkspace,
} from "@/context/AgencyWorkspaceContext";
import { TenantSwitcher } from "@/components/agency/TenantSwitcher";

// Solo la Pipeline è tenant-scoped: tutte le altre pagine dell'Agency Workspace
// (Panoramica, Lead Inbox, Calendario, Richiami, Impostazioni) sono cross-tenant
// → niente TenantSwitcher.
const TENANT_SCOPED_PATHS = ["/admin/agency/pipeline", "/admin/agency/ai-bot"];

function Inner() {
  const { selectedTenantId, availableTenants, loading } = useAgencyWorkspace();
  const location = useLocation();
  const client = useMemo(() => createAgencyClient(() => selectedTenantId), [selectedTenantId]);
  const showSwitcher = TENANT_SCOPED_PATHS.some((p) => location.pathname.startsWith(p));

  return (
    <div>
      <CallbackNotifier />
      <VoiceProvider>
      {showSwitcher && (
        <div className="flex items-center gap-3 mb-6 flex-wrap">
          <TenantSwitcher />
        </div>
      )}

      {!loading && availableTenants.length === 0 ? (
        <div data-testid="aw-no-tenants" className="sp-card p-10 text-center">
          <Store className="h-10 w-10 mx-auto text-[color:var(--sp-text-muted)] mb-3" />
          <h2 className="font-display text-xl font-black">Non hai ancora saloni assegnati</h2>
          <p className="text-sm text-[color:var(--sp-text-muted)] mt-2">
            Appena ti verrà assegnato un salone con servizio receptionist, apparirà qui.
          </p>
        </div>
      ) : (
        <ApiProvider client={client}>
          <Outlet />
        </ApiProvider>
      )}
      </VoiceProvider>
    </div>
  );
}

export default function AgencyWorkspaceLayout() {
  return (
    <AgencyWorkspaceProvider>
      <Inner />
    </AgencyWorkspaceProvider>
  );
}
